export enum HubMethods {
    RetrieveCurrentCall = 'RetrieveCurrentCall',
    OnCurrentCall = 'OnCurrentCall',
    CreateMeeting = 'CreateMeeting',
    ListMeetings = 'ListMeetings',
    OnMeetingList = 'OnMeetingList',
    OnCallStatus = 'OnCallStatus',
    InviteToCurrentCall = 'InviteToCurrentCall',
    EndCurrentCall = 'EndCurrentCall',
    RetrieveChat = 'RetrieveChat',
    OnChat = 'OnChat',
    UpdateChat = 'UpdateChat',
    SendChatMessage = 'SendChatMessage',
    OnChatMessage = 'OnChatMessage',
    ListChatMessages = 'ListChatMessages',
    OnChatMessageList = 'OnChatMessageList',
    DeleteChatMessage = 'DeleteChatMessage',
    CreateTask = 'CreateTask',
    OnTaskCreate = 'OnTaskCreate',
    UpdateTask = 'UpdateTask',
    DeleteTask = 'DeleteTask',
    ListTasks = 'ListTasks',
    OnTaskList = 'OnTaskList',
    ImportTranscript = 'ImportTranscript',
}
